import Highway from "@dogstudio/highway"

import modular from "modujs"
import { classesInjection, rewriteLinks } from "./utils/transitions"
import FadeTransition from "./modules/FadeTransition"
import Scroller from "./modules/Scroller"
import gsap from "gsap"
import * as modules from "./modules"

const Modular = modular
const app = new Modular({
  modules,
})

// For debbuging purposes
const startTime = performance.now()
window.addEventListener("load", () => {
  const endTime = performance.now()
  const loadTime = endTime - startTime
  console.log(`Page load time: ${loadTime.toFixed(2)}ms`)
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted() {
    rewriteLinks()
    app.init(app)
    return this
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: FadeTransition,
    },
  })

  H.on("NAVIGATE_IN", ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== "popstate") {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true,
      })
    }
  })

  H.on("NAVIGATE_END", ({ to, location }) => {
    if (typeof window.umami !== "undefined") {
      window.umami.track("page_view", {
        path: location.pathname,
        title: to.page.title,
        url: location.href,
      })
    }
  })

  window.H = H
}

document.addEventListener("DOMContentLoaded", init)
